// extracted by mini-css-extract-plugin
export default {"header":"EventsNavigation_header__s4FO7","list":"EventsNavigation_list__Uwpr9","active":"EventsNavigation_active__aP18M"};